import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/shared/api/client';
import type { ApiResponse } from '@/shared/types/api.types';

interface SelectableCandidate {
  id: string;
  name: string;
  email: string;
}

interface CandidateApiResponse {
  id: string;
  name: string;
  email: string;
}

interface UseSelectableCandidatesReturn {
  candidates: SelectableCandidate[];
  isLoading: boolean;
  isError: boolean;
}

export function useSelectableCandidates(
  companyId: string | undefined
): UseSelectableCandidatesReturn {
  const query = useQuery({
    queryKey: ['selectable-candidates', companyId],
    queryFn: async () => {
      if (!companyId) return [];
      const response = await apiClient<ApiResponse<CandidateApiResponse[]>>(
        `/candidates?companyId=${companyId}`,
        { method: 'GET' }
      );
      return response.data.map((c) => ({
        id: c.id,
        name: c.name,
        email: c.email,
      }));
    },
    enabled: !!companyId,
  });

  return {
    candidates: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
